import type { IBootstrapAxisValue } from '@atlas/types'

/**
 * Each brand-axis code mapped to the label of the brand it files under: a brand
 * to its own label, a product to its root brand's. Matches the list's brand
 * sort, which orders a product beside its brand.
 */
export function brandLabelsByCode(values: IBootstrapAxisValue[]): Map<string, string> {
	const byId = new Map(values.map((value) => [value.valueId, value]))
	const rootOf = (value: IBootstrapAxisValue): IBootstrapAxisValue => {
		const seen = new Set<string>()
		let current = value
		while (current.parentId && !seen.has(current.valueId)) {
			seen.add(current.valueId)
			const parent = byId.get(current.parentId)
			if (!parent) break
			current = parent
		}
		return current
	}
	return new Map(values.map((value) => [value.code, rootOf(value).label]))
}
